export default __webpack_public_path__ + "static/media/spr-storyboarder-light.74ac5327.png";